import { ProviderSetting } from "../types";
import { SET_DECLARATION_TYPE, SET_PIN, SET_PROGRAM_NAME, SET_READ_ONLY, SET_COVERAGE_LIMIT_LOCKED, SET_PROVIDER_SETTINGS } from "./authTypes";

export const setPin = (pin: string) => ({
    type: SET_PIN,
    payload: pin,
});

export const setProgramName = (programName: string|undefined) => ({
    type: SET_PROGRAM_NAME,
    payload: programName,
});

export const setDeclarationType = (declarationType: string|undefined) => ({
    type: SET_DECLARATION_TYPE,
    payload: declarationType,
});

export const setReadOnly = (readOnly: boolean) => ({
    type: SET_READ_ONLY,
    payload: readOnly,
});

export const setCoverageLimitLocked = (coverageLimitLocked: boolean) => ({
    type: SET_COVERAGE_LIMIT_LOCKED,
    payload: coverageLimitLocked,
})

export const setProviderSettingsAction = (providerSettings: ProviderSetting | null) => ({
    type: SET_PROVIDER_SETTINGS,
    payload: providerSettings
})